import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
const AsyncWhatsAppStatusTag = Loadable({
  loader: () => import( /* webpackChunkName: "messaging-whatsapp-object-status-tag" */'./WhatsAppStatusTag').then(mod => mod.default).catch(AsyncComponentErrorHandler('messaging-whatsapp-object-status-details')),
  LoadingComponent: () => null
});
export default AsyncWhatsAppStatusTag;